var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Default")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }